import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import Evaluation from '../components/Evaluation.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        let concession = this.el.dataset.concession;
        if (location.hash && location.hash.indexOf('dealer=') > -1) {
            concession = location.hash.split('=')[1];
        }
        const app = createApp({
            template: '<Evaluation concession="'+concession+'" />',
            components: {
                Evaluation,

            },
            data() {
                return {};
            }
        });
        app.mount(self.el)
    }
}
